import React, { useState } from "react";
import { Button, Dropdown, Menu, Space, Typography, Row, Col, Collapse, Switch } from "antd";
import { DownOutlined, LogoutOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withOktaAuth } from "@okta/okta-react";

import { NEW_BLUE } from "../constant/colors";
import { Routes } from "../constant/routes";
import { selectUser, selectSearchedPatients, selectIDPConfig, selectNotificationPreferences } from "../store/selector";
import ACTIONS from "../store/action";
import SupportIcon from "../assets/svg/SupportIcon";
import { logout } from "@tailormed/common-client/services/auth";
import { AppLayout, TailormedLogoIcon, TailormedLogoContainer } from "../component/AppLayout";
import { oktaConfig } from "../constant/config";

import "./MainHeader.css";

const { Text } = Typography;
const { Panel } = Collapse;

const MainHeaderComponent = ({
  t,
  history,
  user,
  openModal,
  setShowSupport,
  idpConfig,
  authState,
  notificationPreferences,
  setNotificationPreferences,
  updateNotificationPreferences
}) => {
  const [menuVisible, setMenuVisible] = useState(false);

  const handleEmailNotificationChange = (checked) => {
    const updatedPreferences = {
      ...notificationPreferences,
      globalPreferences: {
        ...notificationPreferences?.globalPreferences,
        email: checked
      }
    };
    setNotificationPreferences(updatedPreferences);

    updateNotificationPreferences("Global", 0, "email", checked);
  };

  const emailNotificationsEnabled =
    notificationPreferences?.globalPreferences?.email !== undefined
      ? notificationPreferences.globalPreferences.email
      : false;

  const menuKeys = {
    MANAGE_EMAIL_NOTIFICATIONS: "manageEmailNotifications",
    LOGOUT: "logout"
  };

  const handleMenuClick = (e) => {
    const { key } = e;

    if (key === menuKeys.LOGOUT) {
      logout(user, idpConfig, oktaConfig.loginURI);
    }
  };

  const menu = () =>
    idpConfig ? (
      <Menu onClick={handleMenuClick}>
        {authState?.isAuthenticated &&
          user && [
            <Menu.Item key={menuKeys.MANAGE_EMAIL_NOTIFICATIONS}>
              <Collapse ghost>
                <Panel
                  header={t("manage_email_notifications.title")}
                  className="main-header-panel"
                  key="1"
                  showArrow={false}
                >
                  <Row justify="space-between" gutter={[50, 0]}>
                    <Col>
                      <Text>{t("manage_email_notifications.program_open_notifications")}</Text>
                    </Col>
                    <Col>
                      <Switch
                        size="small"
                        checked={emailNotificationsEnabled}
                        onChange={handleEmailNotificationChange}
                      />
                    </Col>
                  </Row>
                </Panel>
              </Collapse>
            </Menu.Item>,
            <Menu.Item key={menuKeys.LOGOUT}>
              <Space>
                <LogoutOutlined />
                <Text>{t("sign_out")}</Text>
              </Space>
            </Menu.Item>
          ]}
      </Menu>
    ) : (
      <></>
    );

  return (
    <AppLayout>
      <Row align="middle">
        <Col span={12}>
          <TailormedLogoContainer id="tailormed_logo" as={Button} type="text" onClick={() => history.push(Routes.ROOT)}>
            <TailormedLogoIcon />
          </TailormedLogoContainer>
        </Col>
        <Col span={12}>
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <Space>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  id="main_header_contact_support"
                  type="text"
                  onClick={() => {
                    setShowSupport(true, undefined);
                    openModal();
                  }}
                >
                  <SupportIcon />
                </Button>
              </div>
              <Dropdown
                trigger="click"
                placement="bottomRight"
                overlay={menu()}
                open={menuVisible && authState?.isAuthenticated}
                onOpenChange={(visible) => setMenuVisible(visible)}
              >
                <Space>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: 40,
                      width: 40,
                      borderRadius: "50%",
                      backgroundColor: "white"
                    }}
                  >
                    <Text strong style={{ color: NEW_BLUE }}>
                      {`${user ? user.firstName.substring(0, 1) : ""} ${user ? user.lastName.substring(0, 1) : ""}`}
                    </Text>
                  </div>
                  <DownOutlined style={{ color: "white" }} />
                </Space>
              </Dropdown>
            </Space>
          </div>
        </Col>
      </Row>
    </AppLayout>
  );
};

const mapStateToProps = createStructuredSelector({
  user: selectUser,
  searchedPatients: selectSearchedPatients,
  idpConfig: selectIDPConfig,
  notificationPreferences: selectNotificationPreferences
});

const mapDispatchToProps = (dispatch) => ({
  selectSearchedPatient: (patient, patientId) => dispatch(ACTIONS.setPatientAction(patient, patientId)),
  searchPatientAct: (text) => dispatch(ACTIONS.searchPatientsAction(text)),
  openModal: () => dispatch(ACTIONS.setShowAssistanceProgramModal(true)),
  setShowSupport: (visible, assistanceProgram) => dispatch(ACTIONS.setShowSupport(visible, assistanceProgram)),
  setNotificationPreferences: (notificationPreferences) =>
    dispatch(ACTIONS.setNotificationPreferences(notificationPreferences)),
  updateNotificationPreferences: (preferenceType, targetId, notificationType, isEnabled) =>
    dispatch(ACTIONS.updateNotificationPreferencesAction(preferenceType, targetId, notificationType, isEnabled))
});

const MainHeader = compose(
  withOktaAuth,
  withRouter,
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(MainHeaderComponent);
export { MainHeader };
